import React from 'react';

export const SEARCH_DEBOUNCE_MS = 400;

// A text box bound locally and written to the URL after a pause, and brought back in line when the
// URL changes underneath it (browser back, Clear filters). One copy for the catalog search, the
// audit run id and the runs issuer box; the third hand-rolled one had no URL→text sync, so Back
// left stale text in the box.
export const useDebouncedSearch = (urlValue, write, delay = SEARCH_DEBOUNCE_MS) => {
  const [text, setText] = React.useState(urlValue);

  React.useEffect(() => {
    setText(urlValue);
  }, [urlValue]);

  React.useEffect(() => {
    if (text === urlValue) return undefined;
    const timer = setTimeout(() => write(text), delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return [text, setText];
};
